import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineMax} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritStatics} from "../../TrueGritStatics";
import {SimpleReelModelEventData, SimpleReelModelState} from "../../../core/reel/ReelInterfaces";
import {TrueGritNormalResultPresentation} from "../TrueGritNormalResultPresentation";
import {TrueGritModel} from "../../TrueGritModel";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TrueGritFreeSpinResultPresentation extends TrueGritNormalResultPresentation {
    public start(flowStateController:FlowStateController) {
        this._stoppedReels = [false, false, false, false, false, false, false, false];

        TrueGritModel.previousReelsAfterCollapse = JSON.parse(JSON.stringify(TrueGrit.model.data.reelsAfterCollapse));

        this._tl = new TimelineMax();

        // #416, #472
        this._tl.add(() => flowStateController.setSkipCallback(() => this.skip(flowStateController)), 0.1);

        const mainReelStopDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.mainReelAllInStopDelayFastSpin : TrueGritStatics.mainReelAllInStopDelay;
        const topReelDelay = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? TrueGritStatics.topReelAllInStopDelayFastSpin : TrueGritStatics.topReelAllInStopDelay;

        this._topReelStopTl = new TimelineMax();
        this._botReelStopTl = new TimelineMax();

        this._topReelStopTl.add([
            TrueGrit.allReelsView.topReelModel.stop(TrueGrit.model.gameData.topTrain.beforeSpellSymbols),
            () => TrueGrit.allReelsView.topReelModel.events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, flowStateController))
        ], topReelDelay);

        if(TrueGrit.model.gameData.xSplits) {
            this._botReelStopTl.add(TrueGrit.allReelsView.bottomReelModel.stop(TrueGrit.model.reelSplitLongReel), topReelDelay);
        } else {
            this._botReelStopTl.add(TrueGrit.allReelsView.bottomReelModel.stop(TrueGrit.model.gameData.botTrain.symbols), topReelDelay);
        }
        this._botReelStopTl.add(() => TrueGrit.allReelsView.bottomReelModel.events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, flowStateController)), topReelDelay);

        let stopTime:number = 0,
            nearWinDelay:number = 0,
            previousReelStopDurations: number[] = [0, 0, 0, 0, 0, 0];
        for(let i:number = 0; i < TrueGrit.model.gameData.reels.length; i++) {
            const reelStopAnimation:TimelineMax = new TimelineMax();

            reelStopAnimation.add(TrueGrit.allReelsView.mainReelModels[i].stop(TrueGrit.model.gameData.reels[i]));
            previousReelStopDurations[i] = reelStopAnimation.totalDuration();
            if (TrueGrit.model.gritGirlNearWinReels[i - 1]) {
                nearWinDelay = previousReelStopDurations[i - 1] - 0.2;
            } else {
                nearWinDelay = 0;
            }
            stopTime += nearWinDelay;

            TrueGrit.allReelsView.mainReelModels[i].events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, flowStateController));

            this._tl.add(reelStopAnimation, stopTime);
            stopTime += mainReelStopDelay;
        }
    }
}